import { Helmet } from "react-helmet-async";

const SITE_NAME = "Provena Registry";
const DEFAULT_DESCRIPTION =
  "Le registre de confiance pour les montres de luxe : provenance, historique de propriété et signalement de vol.";

/**
 * Per-page SEO metadata (title, description, Open Graph, Twitter, canonical).
 * Title is suffixed with the brand name unless `bare` is set.
 */
/**
 * @param {string} [canonicalPath] Chemin canonique, quand la page est servie
 *   sous plusieurs adresses. `/confidentialite` doit désigner
 *   `/politique-confidentialite` comme original, sinon les deux se déclarent
 *   canoniques et Google n'a aucun moyen de choisir.
 */
export const Seo = ({ title, description, image, imageAlt, bare = false, noindex = false, canonicalPath }) => {
  const fullTitle = !title
    ? `${SITE_NAME} · Registre horloger de confiance`
    : bare
      ? title
      : `${title} · ${SITE_NAME}`;
  const desc = description || DEFAULT_DESCRIPTION;
  const origin =
    typeof window !== "undefined" ? window.location.origin : "";
  // Origine + chemin seulement : ni requête, ni ancre.
  //
  // Auparavant on reprenait window.location.href, donc les paramètres. Chaque
  // lien de campagne (`/?utm_source=instagram`) se déclarait alors canonique de
  // lui-même et devenait une page distincte aux yeux de Google. Search Console
  // le signalait en « page en double sans URL canonique sélectionnée ».
  const canonical =
    typeof window !== "undefined"
      ? `${origin}${canonicalPath || window.location.pathname}`
      : undefined;
  const ogImage = image || (origin ? `${origin}/provena-og.png` : undefined);

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:site_name" content={SITE_NAME} />
      {canonical && <meta property="og:url" content={canonical} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta property="og:image:width" content="1200" />}
      {ogImage && <meta property="og:image:height" content="630" />}
      {ogImage && <meta property="og:image:alt" content={imageAlt || fullTitle} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
};

export default Seo;
